
/**
* Funzione per validare il formato della partita IVA in base al paese
* @param {string} vatNumber - Numero di partita IVA da validare
* @param {string} countryCode - Codice del paese (es. "IT", "FR", etc.)
* @returns {boolean|null} - True se il formato è valido, false se non valido, null se vuoto
*/
export function validateVatFormat(vatNumber, countryCode) {
    console.warn('FicooValidator: Using basic validation. Install Pro for advanced features.');

    if ("" === vatNumber) {
        // If empty, consider unvalid
        return null;
    }
    return true;
}


/**
* Validate Italian tax code - both personal (16 chars) and business (11 digits).
* 
* @param {string} taxCode - The tax code to validate.
* @param {string} countryCode - Country ISO code.
* @returns {boolean} - True if tax code is valid, false otherwise.
*/
export function validateItalianTaxCode(taxCode, countryCode) {
    console.warn('FicooValidator: Using basic validation. Install Pro for advanced features.');
    return true;
}

/**
 * Valida un indirizzo email verificando il formato.
 * 
 * @param {string} email - L'indirizzo email da validare
 * @returns {boolean} - True se l'email è valida, false altrimenti
 */
export function validateEmail(email) {
    // Rimuovi spazi extra
    email = email.trim();

    // Email vuota
    if (email.length === 0) {
        return false;
    }

    // Pattern di validazione email
    // Controlla: caratteri ammessi, presenza di @ e dominio con almeno un punto
    const pattern = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$/;

    if (!pattern.test(email)) {
        return false;
    }

    // Verifica che non ci siano domini non validi (esempi: esempio@esempio, esempio@.com)
    const parts = email.split('@');
    if (parts.length !== 2) {
        return false;
    }

    const domain = parts[1];

    // Verifica che il dominio non inizi o finisca con un punto
    if (domain.startsWith('.') || domain.endsWith('.')) {
        return false;
    }

    // Verifica che il dominio contenga almeno un punto
    if (domain.indexOf('.') === -1) {
        return false;
    }

    // Verifica la lunghezza minima del dominio (ex: a.it)
    if (domain.length < 3) {
        return false;
    }

    return true;
}

/**
 * Verifica se una stringa è composta esattamente da 6 o 7 caratteri.
 * 
 * @param {string} str - La stringa da validare
 * @returns {boolean} - True se la stringa ha esattamente 6 o 7 caratteri, false altrimenti
 */
export function validateRecCode(str) {
    // Verifica che l'input sia una stringa
    if (typeof str !== 'string') {
        return false;
    }

    // Rimuovi spazi vuoti all'inizio e alla fine
    const trimmedStr = str.trim();

    // Verifica se la lunghezza è esattamente 6 o 7 caratteri
    return trimmedStr.length === 6 || trimmedStr.length === 7;
}
